import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const ZonesWrapper = styled.div``

export const ZonesSideMenu = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  padding: 2rem 0;
  right: 2rem;
  width: 4rem;
  height: 100%;
  z-index: 1;
`

export const ZonesMapContainer = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 15px;
  position: relative;
`

interface IZonesOrangeCircleProps {
  whiteIcon?: boolean
}

export const ZonesOrangeCircle = styled.div<IZonesOrangeCircleProps>`
  width: 42.5px;
  height: 42.5px;
  background: ${tokens.accent.base};
  box-shadow: ${tokens.shadow.card};
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: 0.3s ease;
  :hover {
    filter: brightness(115%);
  }
  ${(props) => props.whiteIcon && `svg {fill:${tokens.text.primary}}`};
`

export const ZonesMenuContainer = styled.div`
  min-width: 250px;
  position: absolute;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  bottom: 200%;
  right: 0;
  gap: 0.5rem;
  cursor: auto;
  ${props => props.theme.container}
`

export const AreaInputsContainer = styled(ZonesMenuContainer)`
  top: 5%;
  left: 2%;
  position: absolute;
  z-index: 900000;
  height: 90%;
  max-width: 300px;
  ${props => props.theme.container}
`

export const ZoneMenuItem = styled.div`
  width: 225px;
  height: 40px;
  font-weight: 700;
  font-size: 11.6688px;
  line-height: 40px;
  cursor: pointer;
  padding-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease;
  ${props => props.theme.content}

  :hover {
    background-color: ${tokens.surface.inset};
  }


`

export const ZoneMenuTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 0.5rem;
`

export const ZonesAddContainer = styled.div`
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;
`

export const LatLongContainer = styled.div`
  display: flex;
  padding: 1rem;
  justify-content: space-between;
align-items: flex-end;
  width: 400px;
  height: 100px;
  ${props => props.theme.content}
`
export const ZonesSelectContainer = styled.div`
  min-width: 250px;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.theme.content};
`
export const ZonesInputsWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

